import React, { useEffect } from "react";
import { SEO } from "../components/SEO";
import { Handshake, Rocket, DollarSign, ArrowRight, CheckCircle2 } from "lucide-react";
import { Button } from "../components/ui/Button";

export const Parceiros = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white min-h-screen pb-20">
      <SEO 
        title="Seja um Parceiro | RosTech" 
        description="Junte-se a rede de parceiros RosTech e ganhe dinheiro indicando o melhor ERP para oficinas mecânicas do Brasil."
        canonicalUrl="/parceiros"
      />

      <section className="pt-32 pb-20 bg-emerald-900 border-b border-emerald-800 text-white overflow-hidden relative">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-20 pointer-events-none">
          <div className="absolute -top-[20%] -left-[10%] w-[70%] h-[70%] rounded-full bg-emerald-500 blur-[120px]"></div>
          <div className="absolute -bottom-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-emerald-400 blur-[120px]"></div>
        </div>
        <div className="max-w-7xl mx-auto px-6 relative z-10 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-500/20 text-emerald-300 text-sm font-bold tracking-wide uppercase mb-8 border border-emerald-500/20">
            <Handshake className="w-4 h-4" /> Programa de Parcerias
          </div>
          <h1 className="text-5xl md:text-7xl font-black text-white mb-8 tracking-tight">
            Indique a RosTech e <span className="text-emerald-400">fature</span><br />
            com a gente.
          </h1>
          <p className="text-xl text-emerald-100/80 max-w-3xl mx-auto mb-12 leading-relaxed">
            Seja você um consultor, contador, agência ou fornecedor de peças: ajude seus clientes a prosperarem e receba comissões recorrentes.
          </p>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20 text-center">
             <div className="bg-slate-50 border border-slate-100 rounded-3xl p-8 shadow-sm">
                <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                   <DollarSign className="w-8 h-8 text-blue-600" />
                </div>
                <h3 className="font-bold text-xl mb-4 text-slate-900">Comissão Recorrente</h3>
                <p className="text-slate-600 text-sm leading-relaxed">Ganhe até 20% do valor da mensalidade durante o primeiro ano de cada cliente indicado.</p>
             </div>
             
             <div className="bg-slate-50 border border-slate-100 rounded-3xl p-8 shadow-sm">
                <div className="w-16 h-16 bg-emerald-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                   <Rocket className="w-8 h-8 text-emerald-600" />
                </div>
                <h3 className="font-bold text-xl mb-4 text-slate-900">Suporte Dedicado</h3>
                <p className="text-slate-600 text-sm leading-relaxed">Você indica, nós vendemos, nós implantamos e damos todo o suporte técnico.</p>
             </div>
             
             <div className="bg-slate-50 border border-slate-100 rounded-3xl p-8 shadow-sm">
                <div className="w-16 h-16 bg-purple-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                   <Handshake className="w-8 h-8 text-purple-600" />
                </div>
                <h3 className="font-bold text-xl mb-4 text-slate-900">Material de Marketing</h3>
                <p className="text-slate-600 text-sm leading-relaxed">Tenha acesso a apresentações, folders e banners prontos para enviar aos seus clientes.</p>
             </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-3xl font-black text-slate-900 mb-6 leading-tight">
                Como funciona o programa de parceiros?
              </h2>
              <p className="text-slate-600 mb-8 text-lg">
                O processo é muito simples e transparente. Você faz o cadastro, recebe seu link exclusivo e já pode começar a faturar.
              </p>
              <ul className="space-y-6 mb-8">
                 <li className="flex items-start gap-4">
                    <CheckCircle2 className="w-6 h-6 text-emerald-600 shrink-0" />
                    <div>
                       <div className="font-bold text-slate-900 mb-1">1. Faça seu Cadastro</div>
                       <div className="text-slate-600 text-sm">Preencha o formulário e fale com nossa equipe de parcerias para aprovação e onboarding.</div>
                    </div>
                 </li>
                 <li className="flex items-start gap-4">
                    <CheckCircle2 className="w-6 h-6 text-emerald-600 shrink-0" />
                    <div>
                       <div className="font-bold text-slate-900 mb-1">2. Indique Clientes</div>
                       <div className="text-slate-600 text-sm">Compartilhe as vantagens da RosTech com sua carteira de clientes, amigos e parceiros.</div>
                    </div>
                 </li>
                 <li className="flex items-start gap-4">
                    <CheckCircle2 className="w-6 h-6 text-emerald-600 shrink-0" />
                    <div>
                       <div className="font-bold text-slate-900 mb-1">3. Receba Comissões mensais</div>
                       <div className="text-slate-600 text-sm">A cada fatura paga pelo cliente indicado, o valor cai na sua conta automaticamente.</div>
                    </div>
                 </li>
              </ul>
              <Button size="lg" className="shadow-lg shadow-blue-600/20 group">
                 Quero ser parceiro agora <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>
            
            <div className="bg-slate-50 border border-slate-200 rounded-3xl p-8 relative overflow-hidden">
               <img src="https://images.unsplash.com/photo-1556761175-4b46a572b786?auto=format&fit=crop&q=80&w=800" alt="Consultores parceiros" className="w-full h-[400px] object-cover rounded-2xl mb-8" />
               <div className="bg-white p-6 rounded-2xl shadow-xl shadow-slate-200/50 absolute bottom-4 right-4 left-4 border border-slate-100">
                  <h4 className="font-bold text-slate-900 mb-2">Ideal para:</h4>
                  <div className="flex flex-wrap gap-2">
                     <span className="text-xs font-bold bg-slate-100 text-slate-600 px-2 py-1 rounded">Distribuidores de Peças</span>
                     <span className="text-xs font-bold bg-slate-100 text-slate-600 px-2 py-1 rounded">Contabilidades</span>
                     <span className="text-xs font-bold bg-slate-100 text-slate-600 px-2 py-1 rounded">Consultorias SEBRAE</span>
                  </div>
               </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};
